export const API_RESPONSE_STATUS = Object.freeze({
  NORMAL: 0,
  NOT_AUTH: 401,
  NOT_WORKING: 500,
});

export const CONSUMPTION_LIMIT = Object.freeze({
  NO_LIMIT: 0,
  AMOUNT: 1,
  ITEMS: 2,
});

export const HTTP_STATUS = Object.freeze({
  DELETE: 'delete',
  GET: 'get',
  PATCH: 'patch',
  POST: 'post',
});

export const SNACKBAR_TYPES = Object.freeze({
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
});

export const VERIFY_MAIL_TYPES = Object.freeze({
  REGISTER: 'register',
  RESET_PASSWORD: 'resetPassword',
  SET_PASSWORD: 'setPassword',
});

export const MENU_LIST_ITEM_STATUSES = Object.freeze({
  SCHEDULED: 0,
  IN_PROGRESS: 1,
  ENDED: 2,
});

export const MENU_LIST_ITEM_TYPES = Object.freeze({
  DRAFT: 0,
  NORMAL: 1,
  CANCELED: 2,
  COMPLETED: 3,
});

export const MENU_TABS = Object.freeze({
  ALL: 0,
  UN_JOINED: 1,
  JOINED: 2,
  SCHEDULED: 3,
});

export const MENU_TAB_KEYS = Object.freeze({
  [MENU_TABS.ALL]: 'all',
  [MENU_TABS.UN_JOINED]: 'unjoined',
  [MENU_TABS.JOINED]: 'joined',
  [MENU_TABS.SCHEDULED]: 'scheduled',
});

export const ORDERS_TABS = Object.freeze({
  THIS_MONTH: 0,
  PRE_MONTH: 1,
});

export const PAYMENT_STATUS = Object.freeze({
  NOT_PAY: 0,
  PAYED: 1,
});

export const PAYMENT_STATUS_TEXT = Object.freeze({
  [PAYMENT_STATUS.NOT_PAY]: '未付款',
  [PAYMENT_STATUS.PAYED]: '已付款',
});

export const RECEIVE_STATUS = Object.freeze({
  UNRECEIVED: 0,
  RECEIVED: 1,
  CANCELED: 2,
});

export const RECEIVE_STATUS_TEXT = Object.freeze({
  [RECEIVE_STATUS.UNRECEIVED]: '未領取',
  [RECEIVE_STATUS.RECEIVED]: '已領取',
  [RECEIVE_STATUS.CANCELED]: '已取消',
});

export const GROUP_BUYING_STATUS = Object.freeze({
  IN_PROGRESS: 0,
  END: 1,
  COMPLETED: 2,
  CANCELED: 3,
  SCHEDULED: 4,
});

export const GROUP_BUYING_TYPE = Object.freeze({
  DRAFT: 0,
  NORMAL: 1,
  CANCELED: 2,
  FINISHED: 3,
});

export const GROUP_BUYING_STATUS_TEXT = Object.freeze({
  [GROUP_BUYING_STATUS.IN_PROGRESS]: '進行中',
  [GROUP_BUYING_STATUS.END]: '已截止',
  [GROUP_BUYING_STATUS.COMPLETED]: '已完成',
  [GROUP_BUYING_STATUS.CANCELED]: '已取消',
  [GROUP_BUYING_STATUS.SCHEDULED]: '排程中',
});

export const GROUP_BUYING_TYPE_TEXT = Object.freeze({
  [GROUP_BUYING_TYPE.DRAFT]: '草稿',
  [GROUP_BUYING_TYPE.CANCELED]: '已取消',
  [GROUP_BUYING_TYPE.FINISHED]: '已完成',
});

export const KEY_CODES = Object.freeze({
  ENTER: 27,
});

export const ENTREE_LIMIT = Object.freeze({
  MINIMUM: 1,
  MAXIMUM: 999,
});

export const ENTREE_COUNT = Object.freeze({
  MINIMUM: 1,
  MAXIMUM: 99,
});

export default {
  API_RESPONSE_STATUS,
  CONSUMPTION_LIMIT,
  ENTREE_COUNT,
  ENTREE_LIMIT,
  GROUP_BUYING_STATUS_TEXT,
  GROUP_BUYING_STATUS,
  HTTP_STATUS,
  KEY_CODES,
  MENU_LIST_ITEM_STATUSES,
  MENU_TAB_KEYS,
  MENU_TABS,
  ORDERS_TABS,
  PAYMENT_STATUS_TEXT,
  PAYMENT_STATUS,
  RECEIVE_STATUS_TEXT,
  RECEIVE_STATUS,
  SNACKBAR_TYPES,
  VERIFY_MAIL_TYPES,
};
